import React, { useContext } from "react";
import { Menu } from "antd";
import TopicEditor from "../../../../../Components/TopicEditor";
import useModalHandler from "../../../../../../../utils/useModalHandler";
import { DiscussContent } from "../../../../context";

interface TopicManageProps {
    onEditOk(): void;
}

export default function TopicManage({ onEditOk }: TopicManageProps) {
    const modal = useModalHandler();
    const { topicType } = useContext(DiscussContent);

    const menu = (
        <Menu>
            {/*<Menu.Item onClick={modal.open}>修改设置</Menu.Item>*/}
            <Menu.Item>结束讨论</Menu.Item>
        </Menu>
    );

    return (
        <React.Fragment>
            {/*{topicType === TopicType.Discuss && (*/}
            {/*    <Dropdown overlay={menu}>*/}
            {/*        <Button type="link">管理主题</Button>*/}
            {/*    </Dropdown>*/}
            {/*)}*/}

            {modal.render(<TopicEditor onOk={onEditOk} />)}
        </React.Fragment>
    );
}
